// import router from '../../router'

import {REGISTRATION_FILL_DATA} from '@/store/mutations'

const state = {
    token: '',
    email: '',
    firstname: '',
    lastname: '',
    referrer_auth_id: null,
    process: false
}

const getters = {}

const mutations = {
    [REGISTRATION_FILL_DATA] (state, data) {
        state.email = data.email
        state.firstname = data.name
        state.lastname = data.surname
        state.referrer_auth_id = data.referrer_auth_id
        state.token = data.key
        state.process = true
    }
}

const actions = {
    fillRegistrationData ({ commit }, data) {
        commit(REGISTRATION_FILL_DATA, data)
        // router.push({name: 'AuthRegistrationComplete'})
    }
}

export default {
    state,
    getters,
    actions,
    mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/registration.js